import React from "react";
import Header from "../sharedComponents/Header";
import LandingPageHeader from "../sharedComponents/LandingPageHeader";
import LandingPageCard from "../sharedComponents/LandingPageCard";
import "../../styles/LandingPageHeader.css";
import fallbackLogo from "../../assets/logos/BDOgs-white.svg";
import buildInfo from "../../buildInfo.json";
import { useTenantInfo } from "../../contexts/TenantInfoContext";

const LandingPage = ({ logedInUserMail }) => {
  const { tenantInfo, isLoading } = useTenantInfo();

  const logoUrl = tenantInfo?.logoUrl || fallbackLogo;
  const companyName = tenantInfo?.companyName || "Intelligent Virtual Assistant (IVA)";
  const showChatButton = tenantInfo?.showChatButton ?? true;
  const showAppsButton = tenantInfo?.showAppsButton ?? true;

  if (isLoading) {
    return (
      <div className="LandingPageHeader loading">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className="LandingPage landingpageclass">
      <div className="HeaderWithCover">
        <Header logoUrl={logoUrl} logedInUserMail={logedInUserMail} />
        <LandingPageHeader
          companyName={companyName}
          showChatButton={showChatButton}
          showAppsButton={showAppsButton}
        />
      </div>
      <LandingPageCard />
      <span className="build-version">v{buildInfo.version} &middot; {buildInfo.buildDate}</span>
    </div>
  );
};

export default LandingPage;
